// import axios from 'axios';
// import React, { useState, useEffect } from 'react';
// import { Modal, Button, Form, Image } from 'react-bootstrap';
// import Swal from 'sweetalert2';

// const EditProfileModal = ({ setShow, show, user, handleFileUpload }) => {
//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     bio: "",
//     tagline: "",
//     profile_pic: "",
//     social_links: []
//   });

//   const [profilePreview, setProfilePreview] = useState("");
//   const token = localStorage.getItem("jwttoken");

//   // Fetch user data when the modal is opened
//   useEffect(() => {
//     if (show) {
//       axios
//         .get("https://tdtlworld.com/dss-kaas-backend/lms/user/", {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         })
//         .then((response) => {
//           const userData = response.data;
//           setFormData({
//             first_name: userData.first_name || "",
//             last_name: userData.last_name || "",
//             bio: userData.bio || "",
//             tagline: userData.tagline || "",
//             profile_pic: userData.profile_pic || "",
//             social_links: userData.social_links || []
//           });
//           setProfilePreview(userData.profile_pic || "");
//         })
//         .catch((reason) => {
//           console.error("Failed to fetch user data:", reason);
//           Swal.fire({
//             icon: "error",
//             title: "Failed to Load Data",
//             text: "There was an error loading your profile data.",
//             confirmButtonText: "OK",
//           });
//         });
//     }
//   }, [show]);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleProfilePicChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setProfilePreview(reader.result);
//         setFormData({ ...formData, profile_pic: reader.result });
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSave = (e) => {
//     axios
//       .patch("https://tdtlworld.com/dss-kaas-backend/lms/user/", e, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         console.log(response.data);
//         Swal.fire({
//           icon: "success",
//           title: "Profile Updated",
//           text: "Your profile details have been successfully updated!",
//           confirmButtonText: "OK",
//         });
//         setShow(false);
//       })
//       .catch((reason) => {
//         console.error("Failed to update profile:", reason);
//         Swal.fire({
//           icon: "error",
//           title: "Failed to Update Profile",
//           text: "There was an error updating your profile. Please try again.",
//           confirmButtonText: "OK",
//         });
//       });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     let newData = {};

//     Object.keys(formData).forEach((k) => {
//       if (formData[k]) {
//         newData[k] = formData[k];
//       }
//     });

//     console.log(newData);

//     handleSave(newData);
//   };

//   const handleClose = () => setShow(false);

//   return (
//     <>
//       <Modal
//         show={show}
//         onHide={handleClose}
//         centered
//         backdrop="static"
//         keyboard={false}
//         style={{ opacity: 1 }}
//       >
//         <Modal.Header
//           closeButton
//           style={{
//             backgroundColor: "#f8f9fa",
//             borderBottom: "none",
//             paddingBottom: "0",
//           }}
//         >
//           <Modal.Title
//             style={{
//               color: "#B8529E",
//               textAlign: "center",
//               width: "100%",
//               fontWeight: "bold",
//             }}
//           >
//             Edit Profile
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{ padding: "20px 30px" }}>
//           <Form onSubmit={handleSubmit}>
//             <Form.Group controlId="formFirstName">
//               <Form.Label style={{ fontWeight: "bold", color: "#B8529E" }}>
//                 First Name
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 name="first_name"
//                 value={formData.first_name}
//                 onChange={handleChange}
//                 style={{
//                   borderRadius: "10px",
//                   borderColor: "#B8529E",
//                 }}
//               />
//             </Form.Group>

//             <Form.Group controlId="formLastName" className="mt-3">
//               <Form.Label style={{ fontWeight: "bold", color: "#B8529E" }}>
//                 Last Name
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 name="last_name"
//                 value={formData.last_name}
//                 onChange={handleChange}
//                 style={{
//                   borderRadius: "10px",
//                   borderColor: "#B8529E",
//                 }}
//               />
//             </Form.Group>

//             <Form.Group controlId="formTagline" className="mt-3">
//               <Form.Label style={{ fontWeight: "bold", color: "#B8529E" }}>
//                 Tagline
//               </Form.Label>
//               <Form.Control
//                 type="text"
//                 name="tagline"
//                 value={formData.tagline}
//                 onChange={handleChange}
//                 style={{
//                   borderRadius: "10px",
//                   borderColor: "#B8529E",
//                 }}
//               />
//             </Form.Group>

//             <Form.Group controlId="formBio" className="mt-3">
//               <Form.Label style={{ fontWeight: "bold", color: "#B8529E" }}>
//                 Bio
//               </Form.Label>
//               <Form.Control
//                 as="textarea"
//                 name="bio"
//                 rows={3}
//                 value={formData.bio}
//                 onChange={handleChange}
//                 style={{
//                   borderRadius: "10px",
//                   borderColor: "#B8529E",
//                 }}
//               />
//             </Form.Group>

//             <Form.Group controlId="formProfilePic" className="mt-3">
//               <Form.Label style={{ fontWeight: "bold", color: "#B8529E" }}>
//                 Profile Picture
//               </Form.Label>
//               <Button
//                 variant="secondary"
//                 onClick={() => document.getElementById("profilePicInput").click()}
//                 style={{
//                   display: "block",
//                   margin: "10px 0",
//                   backgroundColor: "#B8529E",
//                   border: "none",
//                   width: "100%",
//                   transition: "background-color 0.3s ease, transform 0.3s ease",
//                 }}
//                 onMouseEnter={(e) => {
//                   e.target.style.backgroundColor = "#9b4283";
//                   e.target.style.transform = "scale(1.05)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.backgroundColor = "#B8529E";
//                   e.target.style.transform = "scale(1)";
//                 }}
//               >
//                 Upload
//               </Button>
//               <input
//                 type="file"
//                 id="profilePicInput"
//                 style={{ display: "none" }}
//                 accept="image/*"
//                 onChange={handleProfilePicChange}
//               />
//               {profilePreview && (
//                 <div style={{ textAlign: "center", marginTop: "15px" }}>
//                   <Image
//                     src={profilePreview}
//                     roundedCircle
//                     style={{ width: "150px", height: "150px" }}
//                   />
//                 </div>
//               )}
//             </Form.Group>

//             <Button
//               variant="primary"
//               type="submit"
//               style={{
//                 backgroundColor: "#B8529E",
//                 border: "none",
//                 borderRadius: "10px",
//                 width: "100%",
//                 marginTop: "20px",
//                 padding: "10px",
//                 transition: "background-color 0.3s ease, transform 0.3s ease",
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.backgroundColor = "#9b4283";
//                 e.target.style.transform = "scale(1.05)";
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.backgroundColor = "#B8529E";
//                 e.target.style.transform = "scale(1)";
//               }}
//             >
//               Save Changes
//             </Button>
//           </Form>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default EditProfileModal;

import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Image } from 'react-bootstrap'
import Swal from 'sweetalert2'
import { useTheme, alpha } from '@mui/material/styles'

const EditProfileModal = ({ setShow, show, user, handleFileUpload }) => {
  const theme = useTheme()
  const isDarkMode = theme.palette.mode === 'dark'
  const GOLD = "#D4AF37"

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    profile_pic: '',
    cover_photo: '',
    nickname: '',
    social_links: [],
  })

  const [profilePreview, setProfilePreview] = useState('')
  const [coverPhotoPreview, setCoverPhotoPreview] = useState('')
  const token = localStorage.getItem('jwttoken')

  useEffect(() => {
    if (show) {
      axios
        .get('https://tdtlworld.com/dss-kaas-backend/lms/user/', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const userData = response.data
          setFormData({
            first_name: userData.first_name || '',
            last_name: userData.last_name || '',
            profile_pic: userData.profile_pic || '',
            cover_photo: userData.cover_photo || '',
            nickname: userData.nickname || '',
            social_links: userData.social_links || [],
          })
          setProfilePreview(userData.profile_pic || '')
          setCoverPhotoPreview(userData.cover_photo || '')
        })
        .catch((reason) => {
          console.error('Failed to fetch user data:', reason)
          Swal.fire({
            icon: 'error',
            title: 'Failed to Load Data',
            text: 'There was an error loading your profile data.',
            confirmButtonText: 'OK',
            background: theme.palette.background.paper,
            color: theme.palette.text.primary,
          })
        })
    }
  }, [show, token, theme.palette.background.paper, theme.palette.text.primary])

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const handleProfilePicChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setProfilePreview(reader.result)
        setFormData({ ...formData, profile_pic: reader.result })
      }
      reader.readAsDataURL(file)
    }
  }

  const handleCoverPhotoChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setCoverPhotoPreview(reader.result)
        setFormData({ ...formData, cover_photo: reader.result })
      }
      reader.readAsDataURL(file)
    }
  }

  const handleSave = (e) => {
    axios
      .patch('https://tdtlworld.com/dss-kaas-backend/lms/user/', e, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: 'Profile Updated',
          text: 'Your profile details have been successfully updated!',
          confirmButtonText: 'OK',
          confirmButtonColor: GOLD,
          background: theme.palette.background.paper,
          color: theme.palette.text.primary,
        })
        setShow(false)
      })
      .catch((reason) => {
        console.error('Failed to update profile:', reason)
        Swal.fire({
          icon: 'error',
          title: 'Failed to Update Profile',
          text: 'There was an error updating your profile. Please try again.',
          confirmButtonText: 'OK',
          confirmButtonColor: GOLD,
          background: theme.palette.background.paper,
          color: theme.palette.text.primary,
        })
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    let newData = {}
    Object.keys(formData).forEach((k) => {
      if (formData[k]) {
        newData[k] = formData[k]
      }
    })
    handleSave(newData)
  }

  const handleClose = () => setShow(false)

  const inputStyle = {
    borderRadius: '12px',
    borderColor: isDarkMode ? theme.palette.divider : GOLD,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    padding: '10px 15px',
    transition: 'all 0.3s ease',
  }

  const labelStyle = {
    fontWeight: '800',
    color: GOLD,
    marginBottom: '8px',
    fontSize: '0.9rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  }

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        backdrop='static'
        keyboard={false}
        contentClassName="border-0 shadow-lg"
        style={{ opacity: 1 }}
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: theme.palette.background.paper,
            borderBottom: `1px solid ${theme.palette.divider}`,
            padding: '20px 30px',
            color: theme.palette.text.primary
          }}
        >
          <Modal.Title
            style={{
              color: GOLD,
              textAlign: "left",
              width: "100%",
              fontWeight: "900",
              fontSize: '1.5rem'
            }}
          >
            Edit Profile
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ 
          padding: '30px', 
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary
        }}>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId='formFirstName'>
              <Form.Label style={labelStyle}>First Name</Form.Label>
              <Form.Control
                type='text'
                name='first_name'
                value={formData.first_name}
                onChange={handleChange}
                style={inputStyle}
                className="custom-input"
              />
            </Form.Group>

            <Form.Group controlId='formLastName' className='mt-4'>
              <Form.Label style={labelStyle}>Last Name</Form.Label>
              <Form.Control
                type='text'
                name='last_name'
                value={formData.last_name}
                onChange={handleChange}
                style={inputStyle}
                className="custom-input"
              />
            </Form.Group>

            <Form.Group controlId='formNickname' className='mt-4'>
              <Form.Label style={labelStyle}>Nickname</Form.Label>
              <Form.Control
                type='text'
                name='nickname'
                value={formData.nickname}
                onChange={handleChange}
                style={inputStyle}
                className="custom-input"
              />
            </Form.Group>

            <Form.Group controlId='formProfilePic' className='mt-4'>
              <Form.Label style={labelStyle}>Profile Picture</Form.Label>
              <div className="d-flex align-items-center gap-3">
                <Button
                  variant='outline-primary'
                  onClick={() => document.getElementById('profilePicInput').click()}
                  style={{
                    borderRadius: '50px',
                    padding: '8px 25px',
                    fontWeight: '700',
                    borderColor: GOLD,
                    color: GOLD
                  }}
                  className="hover-gold"
                >
                  Upload Image
                </Button>
                {profilePreview && (
                  <Image
                    src={profilePreview}
                    roundedCircle
                    style={{ width: '60px', height: '60px', objectFit: 'cover', border: `2px solid ${GOLD}` }}
                  />
                )}
              </div>
              <input
                type='file'
                id='profilePicInput'
                style={{ display: 'none' }}
                accept='image/*'
                onChange={handleProfilePicChange}
              />
            </Form.Group>

            <Form.Group controlId='formCoverPhoto' className='mt-4'>
              <Form.Label style={labelStyle}>Cover Photo</Form.Label>
              <div className="d-flex flex-column gap-3">
                <Button
                  variant='outline-primary'
                  onClick={() => document.getElementById('coverPhotoInput').click()}
                  style={{
                    borderRadius: '50px',
                    padding: '8px 25px',
                    fontWeight: '700',
                    borderColor: GOLD,
                    color: GOLD,
                    width: 'fit-content'
                  }}
                  className="hover-gold"
                >
                  Upload Cover
                </Button>
                {coverPhotoPreview && (
                  <Image
                    src={coverPhotoPreview}
                    rounded
                    style={{ width: '100%', maxHeight: '120px', objectFit: 'cover', borderRadius: '12px' }}
                  />
                )}
              </div>
              <input
                type='file'
                id='coverPhotoInput'
                style={{ display: 'none' }}
                accept='image/*'
                onChange={handleCoverPhotoChange}
              />
            </Form.Group>

            <Button
              variant='primary'
              type='submit'
              style={{
                backgroundColor: GOLD,
                border: "none",
                borderRadius: "50px",
                width: "100%",
                marginTop: "40px",
                padding: "12px",
                fontWeight: "800",
                fontSize: '1rem',
                boxShadow: `0 4px 15px ${alpha(GOLD, 0.3)}`,
                color: '#fff'
              }}
              className="save-btn"
            >
              SAVE ALL CHANGES
            </Button>
          </Form>
        </Modal.Body>
        <style>{`
          .custom-input:focus {
            background-color: ${theme.palette.background.paper} !important;
            color: ${theme.palette.text.primary} !important;
            border-color: ${GOLD} !important;
            box-shadow: 0 0 0 0.25rem ${alpha(GOLD, 0.15)} !important;
          }
          .custom-input::placeholder {
            color: ${theme.palette.text.secondary};
            opacity: 0.6;
          }
          .hover-gold:hover {
            background-color: ${GOLD} !important;
            color: white !important;
          }
          .save-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px ${alpha(GOLD, 0.4)};
            background-color: #c4a030 !important;
          }
          .modal-content {
             background-color: ${theme.palette.background.paper};
          }
          .btn-close {
            filter: ${isDarkMode ? 'invert(1) grayscale(100%) brightness(200%)' : 'none'};
          }
        `}</style>
      </Modal>
    </>
  )
}

export default EditProfileModal
